import { apiRequest } from "./axiosConfig";

// Add a new save search
export const addSaveSearch = async (searchData) => {
  return apiRequest("post", "/api/saveSearches/add", searchData);
};

// Remove a save search
export const removeSaveSearchApi = async (id) => {
  return apiRequest("delete", `/api/saveSearches/delete/${id}`);
};

// Fetch save search for a user
export const fetchSaveSearch = async (nextUrl) => {
  const url = nextUrl ? nextUrl : `/api/saveSearches?limit=10`;
  return apiRequest("get", url);
};
